import type { ReactNode } from 'react'

type KpiCardProps = {
  label: string
  value: ReactNode
  hint?: ReactNode
  tone?: 'default' | 'warning' | 'danger' | 'success'
}

const toneBorder: Record<NonNullable<KpiCardProps['tone']>, string> = {
  default: 'border-[var(--color-border)]',
  warning: 'border-amber-200',
  danger: 'border-red-200',
  success: 'border-emerald-200',
}

/**
 * KPI summary card — wire only real counts from store/API.
 */
export function KpiCard({
  label,
  value,
  hint,
  tone = 'default',
}: KpiCardProps) {
  return (
    <div
      className={`rounded-[var(--radius-lg)] border bg-[var(--color-surface)] px-4 py-3 shadow-[var(--shadow-level-1)] ${toneBorder[tone]}`}
    >
      <div className="text-xs font-semibold tracking-wide text-[var(--color-text-muted)] uppercase">
        {label}
      </div>
      <div className="mt-1 text-xl font-semibold tabular-nums text-[var(--color-text)] whitespace-nowrap">
        {value}
      </div>
      {hint ? (
        <div className="mt-1 text-xs text-[var(--color-text-muted)]">{hint}</div>
      ) : null}
    </div>
  )
}
